<template>
    <b-col tag="li" sm="6">
        <router-link :to="{name: 'volume-store'}">
            <svg-storage/>
            <p>Add extra storage</p>
            <p>Add extra storage to your instances</p>
        </router-link>
    </b-col>
</template>

<script>
const svgStorage = () => import('@/components/svg/create-button/svg-storage');

export default {
    components: {
        svgStorage
    }
}
</script>
